module.exports = __webpack_public_path__ + "static/img/ky_pic8.7c27ce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ky_pic8.png
// module id = Zn8I
// module chunks = 15